import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';
import { useTriggerFieldInitialization } from '../../../../controllers/issue-adjustments/hooks/use-trigger-field-initialization';
import { SingleAppRenderer } from './single-app-renderer';
export var AppsRenderer = function AppsRenderer(_ref) {
  var ForgeAppRenderer = _ref.ForgeAppRenderer,
    apps = _ref.apps;
  var _useTriggerFieldIniti = useTriggerFieldInitialization(),
    _useTriggerFieldIniti2 = _slicedToArray(_useTriggerFieldIniti, 1),
    triggerFieldInitializationKey = _useTriggerFieldIniti2[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, apps.map(function (_ref2) {
    var forgeExtension = _ref2.forgeExtension,
      uiModificationsConfig = _ref2.uiModificationsConfig;
    var _parseExtensionId = parseExtensionId(forgeExtension.id),
      appId = _parseExtensionId.appId,
      envId = _parseExtensionId.environmentId;
    return /*#__PURE__*/React.createElement(AnalyticsContext, {
      key: "".concat(forgeExtension.id, "-").concat(triggerFieldInitializationKey),
      data: {
        attributes: {
          appId: appId,
          envId: envId
        }
      }
    }, /*#__PURE__*/React.createElement(SingleAppRenderer, {
      forgeExtension: forgeExtension,
      uiModificationsConfig: uiModificationsConfig,
      ForgeAppRenderer: ForgeAppRenderer
    }));
  }));
};